<div class="modal-header">
  <div class="modal-title">{{ 'workspace_edit_newWorkspaceUser' | translate }}</div>
</div>
<div class="modal-body">
  <form [formGroup]="userForm">
    <h5 class="text-center mb-4">{{ 'workspace_edit_addNewUser' | translate }}</h5>

    <div class="row-mt-4">
      <div class="col">
        <div class="mb-2" [class.invalid]="nameChanged && !userForm.controls['username'].valid">
          <mtm-inviter-dropdown
            class="flex-fill me-1"
            [data]="companyUsers"
            [(value)]="invitedUsers"
            [internalUsersOnly]="true"
            (selectedInvitersChange)="nameChange($event)"
            [iconSize]="24"
            [userInfo]="'nameOnly'"
            [inputPlaceholder]="'nameOrEmail' | translate"
            [singleInput]="true"
            [asClassicDropdown]="true">
          </mtm-inviter-dropdown>
          <input [hidden]="true" class="form-control" type="text" formControlName="username" />

          @if (userForm.controls['username'].errors?.duplicate) {
            <div class="error-msg">
              {{ userForm.controls.username.errors.duplicate.message | translate }}
            </div>
          }
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <button class="btn btn-outline-secondary btn-lg w-100" type="button" (click)="cancel()">
          <span>{{ 'cancel' | translate }}</span>
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-danger btn-lg w-100"
          [disabled]="!userForm.valid || sending"
          type="submit"
          (click)="save()">
          <span>{{ 'add' | translate }}</span>
        </button>
      </div>
    </div>
  </form>
</div>
